
import { SWRConfiguration, SWRResponse } from "swr";

import { GetSourceDataReport, IReturn, QuerySourceDataEvents, GetSourceDataReportResponse, SourceDataEvent, SourceDataEventContext, SourceDataFormContext, SourceDataPoint } from "@/api/dtos";
import { useMemo } from "react";
import useGet from "@/hooks/api/useGet";

const getData = (response?: SWRResponse<GetSourceDataReportResponse, GetSourceDataReportResponse>) => response?.data?.report;
const getError = (response?: SWRResponse<GetSourceDataReportResponse, GetSourceDataReportResponse>) => (response?.error ?? response?.data)?.responseStatus;
const getAdditionalState = (response?: SWRResponse<GetSourceDataReportResponse, GetSourceDataReportResponse>) => ({
    eventMap: response?.data?.report?.events.reduce<Record<number,SourceDataEventContext>>((a, b) => {
        a[b.id!] = b;

        return a;
    }, {}),
    
    formMap: response?.data?.report?.forms.reduce<Record<number,SourceDataFormContext>>((a, b) => {
        a[b.id!] = b;

        return a;
    }, {}),
    
    pointMap: response?.data?.report?.points.reduce<Record<number,SourceDataPoint>>((a, b) => {
        a[b.id!] = b;

        return a;
    }, {})
    
});

export const useSourceDataReport = (query?: Partial<GetSourceDataReport>, configuration?: SWRConfiguration | undefined) => {
    const request = useMemo(() => {
        if (!query) {
            return undefined;
        }

        return () => {
            return new GetSourceDataReport(query);
        }
    }, [query]);

    return useGet(request, { getData, getError, getAdditionalState }, configuration);
}

export default useSourceDataReport;